<template>
  <div class="home">
    <div class="left">
      <div class="equipment-stat">
        <div class="title">
          <span>设备统计</span>
        </div>
        <div class="ring">
          <Ring :needData="this.homeData.getDeviceStatsData"></Ring>
        </div>
      </div>
      <div class="handle-stat">
        <div class="title">
          <span>处理量统计</span>
        </div>
        <div class="bar">
          <Bar :needData="homeData.getProcessingCapacityStatisticsData"></Bar>
        </div>
      </div>
      <div class="warning">
        <div class="title">
          <span>实时报警</span>
        </div>
        <div class="warning-data">
          <ul>
            <li v-for="(item, index) in this.homeData.getRealTimeAlarmData" :key="index">
              <span>【 {{ item.type }} 】</span>
              <span>{{ item.data }}</span>
              <span>{{ item.time }}</span>
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="gas">
        <div class="title">
          <span>气体分析统计</span>
        </div>
        <div class="gas-line">
          <GasLine :needData='this.homeData.getGasAnalysisStatisticsData'></GasLine>
        </div>
      </div>
      <div class="pressure">
        <div class="title">
          <span>压力分析统计</span>
        </div>
        <div class="pressure-line">
          <PressureLine :needData='this.homeData.getPressureAnalysisStatisticsData'></PressureLine>
        </div>
      </div>
      <div class="energy">
        <div class="title">
          <span>能耗分析统计</span>
        </div>
        <div class="energy-line">
          <EnergyLine :needData='this.homeData.getEnergyConsumptionAnalysisStatisticsData'></EnergyLine>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
//getDeviceStats,
//getProcessingCapacityStatistics,
//  getRealTimeAlarm,
//getGasAnalysisStatistics,
//getPressureAnalysisStatistics,
//getEnergyConsumptionAnalysisStatistics,
} from "../api/api";
import EnergyLine from "../components/EnergyLine";
import PressureLine from "../components/pressureLine";
import GasLine from "../components/GasLine";
import Bar from "../components/bar";
import Ring from "../components/ring";
export default {
  name: "home",
  data() {
    return {
      homeData: {
        getDeviceStatsData:[], //设备统计
        getProcessingCapacityStatisticsData: "", //处理量统计
        getRealTimeAlarmData:"",//实时报警
        getGasAnalysisStatisticsData:"" ,//气体分析统计
        getPressureAnalysisStatisticsData:"" ,//压力分析统计
        getEnergyConsumptionAnalysisStatisticsData:'', //能耗分析统计
      },
    };
  },
  created() {
    
  },
  mounted() {
    // window.equipmentId = this.equipmentId;
    this.homeDate();
  },
  methods: {
    homeDate() {
      //设备统计
//    getDeviceStats().then((res) => {
//         console.log(res.echartData, "设备统计");
//      if (res.code == 200) {
          this.homeData.getDeviceStatsData = [{"name": "正常","value": 7,},{"name": "停机维护","value": 0,},{"name": "预警","value": 4,},{"name": "报警","value": 0,}
        ];
//      }
//    });

      //处理量统计
//    getProcessingCapacityStatistics().then((res) => {
//         console.log(res, "处理量统计");
        this.homeData.getProcessingCapacityStatisticsData = [{"year": 1, "leftsewage": 400, "productionsewage": 700},
																														{"year": 2, "leftsewage": 380, "productionsewage": 670},
																														{"year": 3, "leftsewage": 411, "productionsewage": 702},
																														{"year": 4, "leftsewage": 534, "productionsewage": 770},
																														{"year": 5, "leftsewage": 506, "productionsewage": 751},
																														{"year": 6, "leftsewage": 576, "productionsewage": 802}];
//    });

      //实时报警
//    getRealTimeAlarm().then((res) => {
//         console.log(res, "实时报警");
       this.homeData.getRealTimeAlarmData =  [
            {"name": "北环园区1号流量仪表",
							"status": "已受理",
							"time": "2022-07-19 15:21:32",
							"type": "预警",
						},{
							"name": "北环园区1号气体仪表",
							"status": "已受理",
							"time": "2022-07-19 15:21:32",
							"type": "预警",
						},{
							"name": "北环园区2号流量仪表",
							"status": "已受理",
							"time": "2022-07-19 15:21:32",
							"type": "预警",
						},{
							"name": "蔡家园区1号压力仪表",
							"status": "已受理",
							"time": "2022-07-19 15:21:32",
							"type": "预警",
						}
       ] ;

//    });

      //气体分析统计
//    getGasAnalysisStatistics().then((res) => {
//         console.log(res, "气体分析统计");
        this.homeData.getGasAnalysisStatisticsData = [
        {"highest": 100,
				"minimum": 12,
				"month": 1,
				'standard': 63},{"highest": 66,
				"minimum": 18,
				"month": 2,
				'standard': 67},{"highest": 99,
				"minimum": 12,
				"month": 3,
				'standard': 73},{"highest": 99,
				"minimum": 10,
				"month": 4,
				'standard': 66},{"highest": 78,
				"minimum": 18,
				"month": 5,
				'standard': 77},{"highest": 88,
				"minimum": 13,
				"month": 6,
				'standard': 76}
        ];
//    });

      //压力分析统计
//    getPressureAnalysisStatistics().then((res) => {
//         console.log(res, "压力分析统计");
       this.homeData.getPressureAnalysisStatisticsData = [
        {"highest": 50,
				"minimum": 12,
				"month": 1,
				'standard': 63},{"highest": 88,
				"minimum": 18,
				"month": 2,
				'standard': 67},{"highest": 80,
				"minimum": 12,
				"month": 3,
				'standard': 77},{"highest": 99,
				"minimum": 10,
				"month": 4,
				'standard': 55},{"highest": 77,
				"minimum": 18,
				"month": 5,
				'standard': 66},{"highest": 92,
				"minimum": 13,
				"month": 6,
				'standard': 67}
        ];
//    });

      //能耗分析统计
//    getEnergyConsumptionAnalysisStatistics().then((res) => {
        // console.log(res, "能耗分析统计");
        this.homeData.getEnergyConsumptionAnalysisStatisticsData = [
        {"highest": 90,
				"minimum": 12,
				"month": 1,
				'standard': 63},{"highest": 92,
				"minimum": 18,
				"month": 2,
				'standard': 77},{"highest": 10,
				"minimum": 12,
				"month": 3,
				'standard': 73},{"highest": 89,
				"minimum": 10,
				"month": 4,
				'standard': 66},{"highest": 68,
				"minimum": 18,
				"month": 5,
				'standard':87},{"highest": 50,
				"minimum": 13,
				"month": 6,
				'standard': 16}
        ];
//    });
    },
  },
  components: {
    EnergyLine,
    PressureLine,
    GasLine,
    Bar,
    Ring,
  },
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
  position: absolute;
}
.left {
  width: 17.7%;
  height: 81.5%;
  margin-top: 10vh;
}

.left div .title {
  width: 17vw;
  height: 2.4vh;
  margin-left: 0.7vw;
  background: url("../assets/img/title.png") no-repeat;
  background-size: 100% 100%;
}
.left div .title span {
  font-size: 0.75vw;
  color: white;
  display: flex;
  margin-left: 1vw;
  height: 1.1vh;
  line-height: 2.4vh;
  font-family: pangmenzhengdao;
}

.equipment-stat {
  width: 100%;
  height: 23vh;
}

.equipment-stat .ring {
  width: 100%;
  height: 21vh;
}

.handle-stat {
  width: 100%;
  height: 29vh;
}

.handle-stat .bar {
  width: 100%;
  height: 28vh;
}

.warning {
  width: 100%;
  height: 29vh;
}

.warning .warning-data {
  width: 100%;
  height: 29vh;
}

.warning .warning-data ul {
  width: 100%;
  height: 100%;
}

.warning .warning-data ul li {
  width: 17vw;
  height: 3.1vh;
  display: flex;
  justify-content: space-around;
  font-size: 0.6vw;
  line-height: 2.5vh;
  font-family: SIMHEI;
  color: #e4f9ff;
  margin-top: 1.5vh;
  margin-left: 0.7vw;
  background: url("../assets/img/warning-list.png") no-repeat;
}
.warning .warning-data ul li span:nth-child(1) {
  margin-left: 0.5vw;
}

.right {
  width: 17.7%;
  height: 81.5%;
  position: absolute;
  right: 0;
  top: 10vh;
}

.right div .title {
  width: 17vw;
  height: 2.4vh;
  background: url("../assets/img/title.png") no-repeat;
  background-size: 100% 100%;
}
.right div .title span {
  font-size: 0.75vw;
  color: white;
  display: flex;
  margin-left: 1vw;
  height: 1.1vh;
  line-height: 2.4vh;
  font-family: pangmenzhengdao;
}

.gas {
  width: 100%;
  height: 27.5vh;
}
.gas-line {
  width: 100%;
  height: 24.5vh;
}

.pressure {
  width: 100%;
  height: 26vh;
}

.pressure-line {
  width: 100%;
  height: 27.5vh;
}

.energy {
  width: 100%;
  height: 27vh;
}

.energy-line {
  width: 100%;
  height: 27vh;
}
</style>
